module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_de@2x-41b1f79243cda56e861d1979c540f260.png";